import { render } from "./PrivacyNotice.vue?vue&type=template&id=1d37d4f7"
import script from "./PrivacyNotice.vue?vue&type=script&lang=js"
export * from "./PrivacyNotice.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__